export function selectRootCurrentAccount() {
    return (state: any) => state?.root?.selectedClient;
}

export function selectRootCompanyId() {
    return (state: any) => state?.root?.selectedClient?.user_pid;
}

export * from '../../../ngrx/store/selectors/root.selector';

export const selectForwardMailComposeContent = (state: any) => state?.root?.forwardMailComposeContent ?? null;
